import { Button } from "./button";
import { t } from "i18next";
import { logoutModalAtom } from "../../atoms/logoutModalAtom";
import { useAtom } from "jotai";
import { store } from "../../utils/store";
import { useEffect, useRef } from "react";

export function LogoutDialog() {
  const [modalState, setModalState] = useAtom(logoutModalAtom);
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (modalState.isOpen && dialogRef.current) {
      dialogRef.current.showModal();
    }
  }, [modalState]);

  if (!modalState.isOpen) {
    return null;
  }

  const resetModal = () => {
    setModalState({ isOpen: false, resolve: null });
  };

  const handleConfirm = () => {
    modalState.resolve?.();
    resetModal();
  };

  return (
    <dialog id={"logout-modal"} className={"modal"} ref={dialogRef}>
      <div className={"modal-box"}>
        <p className={"py-4"}>{t("error.login.expired")}</p>
        <div className={"modal-action"}>
          <form method={"dialog"}>
            <Button className={"btn-primary basis-3/5"} onClick={handleConfirm}>
              {t("common_dialog_yes")}
            </Button>
          </form>
        </div>
      </div>
    </dialog>
  );
}

export const triggerLogoutModal = (): Promise<void> => {
  if (store.get(logoutModalAtom).isOpen) {
    return new Promise(() => {});
  }

  return new Promise((resolve) => {
    store.set(logoutModalAtom, {
      isOpen: true,
      resolve,
    });
  });
};
